module.exports = "https://portperrypedals.ca/_res/img/marc-collection.4f61008.jpg";